<template>
  <div>
    欢迎使用涛米Go排队呼叫系统！
  </div>
</template>
<script>
  export default {
    name: 'HelloWorld',
    data: function () {
      return {
        title: '涛米Go排队呼叫系统'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue